import React from 'react';
import { Image, Edit, Language } from '@material-ui/icons';

export const SUGGESTIONS = [
  { icon: <Image fontSize="small" />, text: 'Create an image' },
  { icon: <Edit fontSize="small" />, text: 'Write or edit' },
  { icon: <Language fontSize="small" />, text: 'Look something up' },
];
